import { toAbsoluteUrl } from '../../../_metronic/helpers'
const Search = ({filters, onChange, loadData, downloadExcel}) => {
  return (
    <div className="row">
      <div className="card col-md-12">
        <div className="card-body">
          {/* Proceso de Liquidación
            <span className='indicator-progress' style={{display: 'block'}}>
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span> */}
          <div className="row">
            <div className="col-xxl-6">
              <label className="fs-4 fw-bold">Rol *</label>
              <input
                name="rol"
                className="form-control"
                type="text"
                placeholder="Rol"
                value={filters.rol}
                onChange={onChange}
              />
            </div>
            <div className="col-xxl-6">
              <label className="fs-4 fw-bold">Paciente *</label>
              <input
                name="paciente"
                className="form-control"
                type="text"
                placeholder="Paciente"
                value={filters.paciente}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-xxl-12">
              <div className='pull-right'>
                <button type='button' className='btn btn-primaryamsm' onClick={() => loadData()} style={{ marginRight: '10px' }}>
                  Buscar
                </button>
                {/* <button className="icon-button btn btn-outline btn-outline-primaryamsm btn-active-light-primary" onClick={() => downloadExcel()}>
                  <div className="icon-container">
                    <span>Excel</span>
                    <img src={toAbsoluteUrl('/media/icons/732220.png')} alt="Descarga Excel" />
                  </div>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Search;
